<div class="fixed inset-0">
  <rid-game [studioDataPackageProvider]="dataPackageProvider" />
</div>
